import { useEffect, useState } from 'react';
import { Hero, Marquee } from '../components/Hero';
import { Float2027, Sketch2027Dialog } from '../components/Float2027';
import { InstagramPresentation } from '../components/InstagramPresentation';
import { Story } from '../components/Story';
import { Showcase, WorkDialog } from '../components/Showcase';
import { Victories } from '../components/Victories';
import { VideoGallery } from '../components/VideoGallery';
import { VideoPlayer } from '../components/VideoPlayer';
import { Fantasti3DTeaser } from '../components/Fantasti3DTeaser';
import { MerchPopup } from '../components/MerchPopup';
import { SocialWall } from '../components/SocialWall';
import { Contact } from '../components/Contact';
import { useUI } from '../context/UIContext';
import { works } from '../data';

export const Home = () => {
  const { setInfo, lenis } = useUI();
  const [work, setWork] = useState(null);
  const [video, setVideo] = useState(null);
  const [sketch2027, setSketch2027] = useState(false);
  const [presentation2027, setPresentation2027] = useState(false);

  useEffect(() => {
    if (work || video || sketch2027 || presentation2027) lenis.current?.stop(); else lenis.current?.start();
  }, [work, video, sketch2027, presentation2027, lenis]);

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const target = document.querySelector(hash);
    if (target) setTimeout(() => target.scrollIntoView(), 140);
  }, []);

  return <>
    <main id="content">
      <Hero onDiscover={() => setWork(works[0])} />
      <Marquee />
      <Float2027 onSketch={() => setSketch2027(true)} onPresentation={() => setPresentation2027(true)} />
      <Story />
      <Showcase onSelect={setWork} />
      <VideoGallery onSelect={setVideo} />
      <Victories />
      <Fantasti3DTeaser />
      <SocialWall />
      <Contact />
    </main>
    <WorkDialog work={work} onClose={() => setWork(null)} />
    <VideoPlayer video={video} onClose={() => setVideo(null)} onSelect={setVideo} />
    <Sketch2027Dialog open={sketch2027} onClose={() => setSketch2027(false)} />
    <InstagramPresentation open={presentation2027} onClose={() => setPresentation2027(false)} />
    <MerchPopup />
  </>;
};
